
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

@import 'src/library/components/LegalSection/styles/law-enforcement-guidelines.scss';

.legal-section {
  &__header {
    margin-bottom: 3rem;
    display: flex;
    align-content: center;
    justify-content: space-between;
  }

  &__print {
    display: none;
    position: relative;
    cursor: pointer;

    @include media-query(tablet) {
      display: inline-block;
      position: relative;

      &:hover,
      &:focus {
        @include focusable($inlineOffset: -10px, $blockOffset: -10px);
        outline: none;
      }

      &-icon {
        padding-right: 0.25rem;
        margin-bottom: -0.25rem;
      }
    }
  }

  &__info {
    font-size: 1rem;
    margin-bottom: 1.5rem;

    span {
      font-size: 1rem;
    }
  }

  &__effective-date {
    margin-right: 4rem;
    display: inline-block;
  }

  &__content {
    > *,
    > * > *,
    > * > * > * {
      margin-bottom: 1.5rem;
    }

    ul li {
      margin-left: 2rem;
      list-style: disc;
    }

    ol li {
      margin-left: 2rem;
      list-style: decimal;
    }

    li {
      margin-bottom: 0.5rem;
    }

    li p {
      margin-bottom: 0.5rem;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin-top: 3rem;
      font-weight: normal;
    }

    h2,
    .legal-section__content-title {
      font-size: 1.625rem;
      scroll-margin-top: 113px;
    }

    button[data-cookie-consent-banner] {
      text-decoration: underline;
      font-weight: bold;
      cursor: pointer;
    }

    .table-wrapper {
      width: 100%;
      overflow-x: auto;
    }

    table {
      text-align: left;
      border-collapse: collapse;
      font-size: 1rem;
    }

    th,
    td {
      padding: 1rem;
      border: 1px solid #f1f1f1;
      vertical-align: top;
    }
  }
}

.legal-section [id='manage-cookies'],
.legal-directory__subheading-links[href='#manage-cookies'] {
  display: none;
}
`